export default __webpack_public_path__ + "static/media/meal-moderate.2fd0eae9.svg";